// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\reset-password-otp.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\reset-password-otp.tsx");
  import.meta.hot.lastModified = "1760464886205.697";
}
// REMIX HMR END

import ResetPasswordOtp from '~/components/auth/ResetPasswordOtp';
export default function ResetPasswordOtpRoute() {
  return <ResetPasswordOtp />;
}
_c = ResetPasswordOtpRoute;
var _c;
$RefreshReg$(_c, "ResetPasswordOtpRoute");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;